module.exports = __webpack_public_path__ + "media/images/emoticons/heart-4afe417f682ed063e25b8769b7399379.gif";